"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = require("react");
function useFocusCodeMirror({ codeMirrorRef, isFocused }) {
    const didFocusCodeMirrorRef = react_1.useRef(false);
    react_1.useEffect(() => {
        if (isFocused && !didFocusCodeMirrorRef.current && codeMirrorRef.current) {
            codeMirrorRef.current.focusCodeMirror();
            didFocusCodeMirrorRef.current = true;
        }
    }, [codeMirrorRef, isFocused]);
}
exports.default = useFocusCodeMirror;
